export const EXSBORDER_CREATE_RESET = 'EXSBORDER_CREATE_RESET'
export const EXSBORDER_CREATE_SET_CREATED = 'EXSBORDER_CREATE_SET_CREATED'
export const EXSBORDER_CREATE_SET_ERROR = 'EXSBORDER_CREATE_SET_ERROR'
export const EXSBORDER_CREATE_SET_VIOLATIONS = 'EXSBORDER_CREATE_SET_VIOLATIONS'
export const EXSBORDER_CREATE_TOGGLE_LOADING = 'EXSBORDER_CREATE_TOGGLE_LOADING'
